import { gql } from '@apollo/client';

/**
 * Fragment for product information within an order
 */
export const ProductFragment = gql`
  fragment ProductFragment on Product {
    id
    externalId
    unit
    name
  }
`;

/**
 * Fragment for order product details (product + amount)
 */
export const OrderProductFragment = gql`
  fragment OrderProductFragment on OrderProduct {
    product {
      ...ProductFragment
    }
    amount
  }
  ${ProductFragment}
`;

/**
 * Base fragment for order details used in search results and single order queries
 */
export const OrderDetailsBaseFragment = gql`
  fragment OrderDetailsBaseFragment on Order {
    id
    referenceId
    createdAt
    deliveryDate
    user {
      id
      phone
      name
    }
    buyer {
      name
      displayName
      referenceId
      fullAddress
    }
    restaurant {
      restaurantName
    }
    supplier {
      phone
      name
    }
    orderProducts {
      ...OrderProductFragment
    }
    supplierRefId
    body
    isTest
    status
    orderSupplierStatus
    createdContext
  }
  ${OrderProductFragment}
`;

/**
 * Extended fragment for detailed order view including PDF and chat info
 */
export const OrderDetailsFragment = gql`
  fragment OrderDetailsFragment on Order {
    ...OrderDetailsBaseFragment
    pdf(downloadable: true)
    chat {
      id
      deliveryAddress
    }
  }
  ${OrderDetailsBaseFragment}
`;
